import { useContext } from "react"
import { AiTeammateContext } from "../context"
import { SendMessageContext } from "../context/send-message"

export function useAiTeammateContext() {
  return useContext(AiTeammateContext)
}

export function useSendMessageContext() {
  return useContext(SendMessageContext)
}
